import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Header } from 'src/components/header';
import { Progress } from 'src/components/progress';
import { ViewOnlyAlert } from 'src/components/viewOnlyAlert';
import { PATHS } from 'src/constants/paths';
import {
  useGetLocationGroup,
  useGetLocationsCountByGroup,
  useGetProjectConfig,
} from 'src/hooks';
import { useApiErrorNavigator } from 'src/hooks/navigation';
import { ILocationGroup } from 'src/interfaces';
import { lang } from 'src/utils';
import { useUserRole } from 'src/utils';

import { LocationTimingsTimeGrid } from './modules/locationGroupTimingsGrid/LocationGroupTimingsGrid';
import { LocationGroupTimingsHeader } from './modules/locationGroupTimingsHeader/LocationGroupTimingsHeader';

export const TimingLocationGroupPage = () => {
  const { locationGroupId = '' } = useParams();
  const {
    data: locationGroup,
    error,
    isLoading: isLoadingLocationGroup,
  } = useGetLocationGroup(locationGroupId.toString());
  useApiErrorNavigator(error);

  const { isViewOnly } = useUserRole();

  const { data: locationsCount, isLoading: isLoadingLocations } =
    useGetLocationsCountByGroup(
      [`locationGroups.id=${locationGroupId}`],
      Boolean(locationGroupId),
    );

  const { data: projectConfig, isLoading: isLoadingGlobalConfig } =
    useGetProjectConfig();
  const rbStoreIntegration = projectConfig?.rbStoreIntegration ?? false;

  return (
    <Box>
      {isLoadingLocationGroup || isLoadingLocations || isLoadingGlobalConfig ? (
        <Progress />
      ) : (
        <>
          <Header
            title={`${locationGroup?.name} timings`}
            actionBar={isViewOnly && <ViewOnlyAlert />}
            breadcrumbItems={[
              {
                label: lang.locationGroup,
                link: `${PATHS.LOCATION_GROUPS}`,
              },
              {
                label: lang.timings,
              },
            ]}
          />
          <LocationGroupTimingsHeader
            locationsCount={locationsCount}
            locationGroupData={locationGroup as ILocationGroup}
            rbStoreIntegration={rbStoreIntegration}
          />
          <LocationTimingsTimeGrid
            locationsCount={locationsCount}
            locationGroupData={locationGroup as ILocationGroup}
            rbStoreIntegration={rbStoreIntegration}
          />
        </>
      )}
    </Box>
  );
};
